module.exports = __webpack_public_path__ + "img/yyh.ab1b79bc.png";